export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Apps-ffd35f6f7db78d9855380063314b722b.svg";